/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { mapValues, get, isEqual } from 'lodash';
import { Modal } from 'react-bootstrap';

import { FilterTypes, Filter } from '../../components/Filters';
import AudienceSegment from '../../components/AudienceSegment';
import { extractFilterValues, getTitleFilterId } from '../../utils/filters';

import { affinityFilters as config } from './config';

const AffinityFilters = ({
  filterFields,
  onApply,
  onReset,
  showTable,
  openSegment
}) => {
  const [selected, setSelected] = useState('content');
  const [pageFilters, setPageFilters] = useState({});
  const [buildMode, setBuildMode] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    setPageFilters(filterFields);
  }, [filterFields]);

  const selectCategory = e => {
    setSelected(e.target.value);
  };

  const onChangeBooleanSeparator = (filter, option) => {
    setPageFilters({
      ...pageFilters,
      [filter]: { ...pageFilters[filter], booleanSeparator: option.value }
    });
  };

  const filterChange = (f, v) => {
    setPageFilters({
      ...pageFilters,
      [f]: { ...pageFilters[f], value: v }
    });
  };

  const criteraButton = (text, nav) => {
    const onClickButton = () => {
      setShowEditModal(true);
      setSelected(nav);
    };
    return (
      <button onClick={onClickButton} className="tvt-affinity__criteria-button">
        {text.replaceAll('Excludes:', '(Excludes)')}
      </button>
    );
  };

  const formatShowCriteria = () => {
    if (!get(pageFilters, 'movie.value', false)) {
      return criteraButton('', 'content');
    }
    const bool = pageFilters.movie.booleanSeparator;
    const text = pageFilters.movie.value.map(s => s.label).join(` ${bool} `);
    return criteraButton(text, 'content');
  };

  const formatDateCriteria = () => {
    if (!get(pageFilters, 'date.value', false)) {
      return criteraButton('all time', 'date');
    }

    const option = config.date[0].options.filter(
      o => o.value === pageFilters.date.value.value
    )[0];

    let dateLable = get(pageFilters, ['date', 'value', 'label'], 'N/A');
    if (option) {
      dateLable = option.label;
    }

    return criteraButton(dateLable, 'date');
  };

  const formatAgeCriteria = () => {
    if (!get(pageFilters, 'age.value', false)) {
      return criteraButton('Age: All', 'demographic');
    }

    return criteraButton(
      `Age: ${pageFilters.age.value.map(a => a.label).join(', ')}`,
      'demographic'
    );
  };

  const formatGenderCriteria = () => {
    if (!get(pageFilters, 'gender.value', false)) {
      return criteraButton('Gender: Any', 'demographic');
    }

    const label = get(
      pageFilters,
      ['gender', 'value', 0, 'label'],
      get(pageFilters, ['gender', 'value', 'label'], 'N/A')
    );
    return criteraButton(`Gender: ${label}`, 'demographic');
  };

  const formatRegionCriteria = () => {
    if (!get(pageFilters, 'country.value', false)) {
      return criteraButton('Region: All', 'demographic');
    }

    const maxCountriesToShow = 7;
    let countryString = pageFilters.country.value.map(a => a.label).join(', ');

    if (pageFilters.country.value.length > maxCountriesToShow) {
      countryString = `${pageFilters.country.value
        .slice(0, maxCountriesToShow)
        .map(a => a.label)
        .join(', ')} ... ${
        pageFilters.country.value.slice(
          maxCountriesToShow,
          pageFilters.country.value.length
        ).length
      } more`;
    }

    return criteraButton(`Region: ${countryString}`, 'demographic');
  };

  const formatSampleCriteria = () => {
    const value = get(pageFilters, ['panel', 'value', 'value'], null);
    if (!value) {
      return criteraButton('Panel: Total', 'demographic');
    }

    return criteraButton(`Panel: Balanced`, 'demographic');
  };

  const onSubmit = () => {
    const filts = mapValues(pageFilters, 'value');
    const booleanFilters = mapValues(pageFilters, 'booleanSeparator');
    setBuildMode(false);
    setShowEditModal(false);
    onApply(filts, { syncWithUrl: true }, booleanFilters);
  };

  const formatAudienceCriteria = () => {
    if (showEditModal) {
      return null;
    }
    return (
      <div className="tvt-affinity__audience-criteria">
        <div className="tvt-affinity__audience-criteria-row">
          People who watched {formatShowCriteria()} from {formatDateCriteria()}
        </div>
        <div className="tvt-affinity__audience-criteria-row">
          with the demographics {formatAgeCriteria()} {formatGenderCriteria()}{' '}
          {formatRegionCriteria()} {formatSampleCriteria()}
        </div>
      </div>
    );
  };

  const buildNav = () => {
    const countCategoryFilters = category => {
      let count = 0;
      config[category].forEach(f => {
        const values = get(pageFilters, [f.id, 'value'], []);
        if (values && Array.isArray(values)) {
          count += values.length;
        } else if (values && values.value) {
          count += 1;
        }
      });
      return count ? `(${count})` : '';
    };
    return (
      <div className="tvt-affinity__audience-builder-pre-filters-nav">
        <div
          className={`tvt-affinity__audience-builder-button-wrapper ${
            selected === 'content' ? 'selected' : ''
          }`}
        >
          <button
            className={selected === 'content' ? 'selected' : ''}
            value="content"
            onClick={selectCategory}
          >
            {`content ${countCategoryFilters('content')}`}
          </button>
        </div>
        <div
          className={`tvt-affinity__audience-builder-button-wrapper ${
            selected === 'demographic' ? 'selected' : ''
          }`}
        >
          <button
            className={selected === 'demographic' ? 'selected' : ''}
            value="demographic"
            onClick={selectCategory}
          >
            {`demographic ${countCategoryFilters('demographic')}`}
          </button>
        </div>
        <div
          className={`tvt-affinity__audience-builder-button-wrapper ${
            selected === 'date' ? 'selected' : ''
          }`}
        >
          <button
            className={selected === 'date' ? 'selected' : ''}
            value="date"
            onClick={selectCategory}
          >
            {`date ${countCategoryFilters('date')}`}
          </button>
        </div>
      </div>
    );
  };

  const showFilters = () => {
    const formatLabel = filt => {
      if (filt.id == 'age' || filt.id === 'country') {
        return 'All';
      }

      if (filt.id === 'show' || filt.id === 'movie') {
        return `Search for a ${filt.id}...`;
      }

      return filt.label;
    };
    return (
      <>
        {config[selected].map(filter => {
          const f = pageFilters[filter.id];
          if (!f) {
            return null;
          }
          return (
            <div className="tvt-affinity__filter_wrapper">
              <div className="tvt-affinity__filter_label">{filter.label}:</div>
              <div
                className={`tvt-affinity__filter-option_wrapper affinity-${filter.id}`}
              >
                <div
                  className={
                    filter.id === 'date'
                      ? ''
                      : 'tvt-filter__multi-value-wrapper'
                  }
                >
                  <Filter
                    key={f.id}
                    isRequired={f.id === 'movie'}
                    hasChanged={f.hasChanged}
                    onChange={filterChange}
                    onUpdateFilterOptions={() => {}}
                    id={f.id}
                    title={f.label}
                    hasBoolean={f.hasBoolean}
                    boolLayout="right"
                    showInlineSelections
                    isToggle={filter.isToggle}
                    toggleOpts={filter.options}
                    toggleTooltip={filter.tooltip}
                    onChangeBooleanSeparator={onChangeBooleanSeparator}
                    {...f}
                    label={formatLabel(f)}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const buildEditFiltersSection = () => (
    <div className="tvt-affinity__audience-builder-pre-filters-wrapper">
      {buildNav()}
      <div className="tvt-affinity__audience-builder-pre-filters">
        {showFilters()}
      </div>
      {selected === 'content' && (
        <div className="tvt-affinity__info">
          At least one movie must be selected to return results.
        </div>
      )}
    </div>
  );

  const resetFilters = () => {
    onReset();
    setPageFilters(filterFields);
    setBuildMode(true);
    setSelected('content');
  };

  const closeModal = () => {
    setPageFilters(filterFields);
    setShowEditModal(false);
  };

  const countAllCategoryFilters = () => {
    let count = 0;
    Object.keys(config).forEach(category => {
      config[category].forEach(f => {
        const values = get(pageFilters, [f.id, 'value'], []);
        const currentValues = get(filterFields, [f.id, 'value'], []);
        if (
          values &&
          Array.isArray(values) &&
          !isEqual(values, currentValues)
        ) {
          count += values.length;
        } else if (values && values.value && !isEqual(values, currentValues)) {
          count += 1;
        }
      });
    });

    return count ? `(${count})` : '';
  };

  const disableApply = () => {
    const currentValues = extractFilterValues(filterFields);
    const values = extractFilterValues(pageFilters);

    return (
      isEqual(values, currentValues) &&
      isEqual(
        get(filterFields, 'movie.booleanSeparator', 'OR'),
        get(pageFilters, 'movie.booleanSeparator', 'OR')
      )
    );
  };

  const handleSegmentChange = () => {};

  const handleApplySegment = segment => {
    const segmentFilters = JSON.parse(segment.filters);
    segmentFilters.forEach(f => {
      pageFilters[f.id] = {
        ...pageFilters[f.id],
        value: f.value,
        booleanSeparator: f.booleanSeparator || 'OR'
      };
    });
    setPageFilters(pageFilters);
    onSubmit();
  };

  if (!Object.keys(pageFilters).length) {
    return null;
  }

  return (
    <div className="tvt-affinity__audience-builder">
      <div className="tvt-affinity__audience-builder-top">
        <div className="tvt-affinity__audience-builder-title">
          {buildMode && !showTable ? 'Audience Builder' : 'Audience Criteria'}
        </div>
        <button
          id="affinity-segment"
          className="tvt-affinity__audience-segment-button"
          onClick={openSegment}
        >
          Use Segment
        </button>
      </div>
      {buildMode && !showTable ? (
        <>
          {buildEditFiltersSection()}
          <div className="tvt-affinity__action-buttons-wrapper">
            <button
              onClick={onSubmit}
              disabled={
                !(
                  get(pageFilters, 'movie.value', false) &&
                  pageFilters.movie.value.length > 0
                )
              }
              className={`homepage__filter-action-button ${
                get(pageFilters, 'movie.value', false) &&
                pageFilters.movie.value.length
                  ? 'active'
                  : 'apply-disabled'
              }`}
            >
              {`Apply${countAllCategoryFilters()}`}
            </button>
            <button
              onClick={resetFilters}
              className={`homepage__filter-action-button reset${
                extractFilterValues(pageFilters).length === 0 ? '-disabled' : ''
              }`}
              disabled={extractFilterValues(pageFilters).length === 0}
            >
              Reset
            </button>
          </div>
        </>
      ) : (
        <div className="tvt-affinity__audience-builder-filters-criteria-wrapper">
          {formatAudienceCriteria()}
        </div>
      )}
      <AudienceSegment
        requiredValues={['movie']}
        onChangeSegment={handleSegmentChange}
        handleApply={handleApplySegment}
        availableFilters={filterFields}
        titleFields={getTitleFilterId(filterFields)}
      />
      <Modal
        className="tvt-affinity__edit-modal"
        show={showEditModal}
        onHide={closeModal}
        backdrop
      >
        <>
          <div className="tvt-affinity__audience-builder-top">
            <div className="tvt-affinity__audience-builder-title">
              Edit Audience
            </div>
          </div>
          {buildEditFiltersSection()}
          <div className="tvt-affinity__action-buttons-wrapper">
            <button
              onClick={onSubmit}
              disabled={disableApply()}
              className={`homepage__filter-action-button ${
                disableApply() ? '' : 'active'
              }`}
            >
              {`Apply${countAllCategoryFilters()}`}
            </button>
            <button
              onClick={closeModal}
              className="homepage__filter-action-button reset"
            >
              Cancel
            </button>
          </div>
        </>
      </Modal>
    </div>
  );
};

AffinityFilters.propTypes = {
  filterFields: FilterTypes.FilterSetType.isRequired,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  showTable: PropTypes.bool.isRequired,
  openSegment: PropTypes.func.isRequired
};
export default AffinityFilters;
